export interface Review {
  reviewerName: string;
  comment: string;
  rating: number;
  createdAt: Date;
  updatedAt: Date;
}

export const reviewFromResponse = (responseData: any): Review => ({
  reviewerName: responseData.reviewer_name,
  comment: responseData.comment,
  rating: responseData.rating,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});
